<template lang="html">
  <section class="sublist-edit">
    <name-input
      :all-des="allDes"
      :is-ready="true"
      :name="storedDataElement.name"
      :should-focus="!storedDataElement.name"
      :de-id="storedDataElement.id"
      :outer-container-class="'row-container'"
      :label-class="'query-label'"
      @on-name-input-changed="onDeNameChanged"
    ></name-input>

    <element-description
      :elem-description="storedDataElement.description"
      @on-element-description-changed="onDeDescriptionChanged"
    ></element-description>

    <div class="row-container">
      <span class="query-label">
        {{ getMessageText(messages.DATA_SOURCE) }}
      </span>
      <div class="row-selection">
        <search-box-simple
          id="searchDatasource"
          :list="sourceList"
          :value="selectedSourceValue"
          @on-search-box-item-selected="onSourceSelected"
        />
      </div>
    </div>

    <div class="row-container">
      <span class="query-label">
        {{ getMessageText(messages.SKIP) }}
      </span>
      <div class="row-selection">
        <b-form-input
          id="skip-input"
          class="form-input"
          :value="storedDataElement.skip"
          v-model="storedDataElement.skip"
          type="number"
          min="0"
          :disabled="!hasSelectedSource"
          @change="onFieldInputChanged"
        ></b-form-input>
      </div>
    </div>

    <div class="row-container">
      <span class="query-label">
        {{ getMessageText(messages.KEEP) }}
      </span>
      <div class="row-selection">
        <b-form-input
          id="keep-input"
          class="form-input"
          :value="storedDataElement.keep"
          v-model="storedDataElement.keep"
          type="number"
          min="0"
          :disabled="!hasSelectedSource"
          @change="onFieldInputChanged"
        ></b-form-input>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { mapState, mapActions } from "vuex";
  import { MUTATION_NAME } from "@/static/global-variables";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import SearchBoxSimple from "@/components/SearchBoxSimple";
  import NameInput from "@/components/NameInput";
  import ElementDescription from "@/components/ElementDescription";

  export default  {
    name: "sublist-edit",
    components: {
      SearchBoxSimple,
      NameInput,
      ElementDescription
    },
    props: {
      appId: {
       type: String
      },
      allDes: {
        type: Object
      },
      de: {
        type: Object
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      sourceList() {
        return this.dataSources.map(e => {
          e.label = e.name;
          return e;
        });
      },
      selectedSourceValue() {
        return this.sourceList.find(e => e.id === this.de.original);
      },
      dataSources() {
        delete this.allDes[this.de.id];
        return expressionBuilder.filterGlobalSources(this.allDes);
      },
      hasSelectedSource() {
        return Boolean(this.storedDataElement.selectedSource);
      }
    },
    watch: {
      selectedSourceValue: {
        handler: function() {
          this.storedDataElement.selectedSource = this.selectedSourceValue;
          this.storedDataElement.skip = this.de.skip;
          this.storedDataElement.keep = this.de.keep;
          this.onFieldInputChanged();
        },
        deep: true,
        immediate: true
      }
    },
    data () {
      return {
        storedDataElement: {
          type: "DATA_EL_SUBLIST",
          name: this.de.name,
          description: this.de.description,
          selectedSource: null,
          skip: null,
          keep: null
        }
      }
    },
    methods: {
      ...mapActions({
        setDataElement: MUTATION_NAME.SET_EDIT_DATA_ELEMENT
      }),
      onSourceSelected(val) {
        this.storedDataElement.skip = null;
        this.storedDataElement.keep = null;
        this.storedDataElement.selectedSource = val.isEmpty? null : val;
        this.setDataElement(this.storedDataElement);
      },
      onFieldInputChanged() {
        this.setDataElement(this.storedDataElement);
      },
      onDeNameChanged(isValidName, nameInput) {
        this.storedDataElement.name = nameInput;
        this.$emit("on-de-name-changed", isValidName);
        this.setDataElement(this.storedDataElement);
      },
      onDeDescriptionChanged(input) {
        this.storedDataElement.description = input;
        this.setDataElement(this.storedDataElement);
      }
    }
  }
</script>

<style scoped lang="scss">
  .sublist-edit {
    min-height: 8rem;
    .row-container {
      display: flex;
      flex-direction: column;
      padding: 0 1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    .query-label {
      flex-basis: 16%;
    }
    .row-selection {
      flex-basis: 84%;
    }
    .form-input {
      max-width: 6rem;
      height: 1.8rem;
      font-size: 0.75rem;
    }
  }
</style>
